export function hasPlatformModifier(event: { metaKey?: boolean; ctrlKey?: boolean }): boolean {
  return !!(navigator.platform.toUpperCase().includes('MAC') ? event.metaKey : event.ctrlKey);
}

export function isMacControlClick(event: { ctrlKey?: boolean }): boolean {
  return !!event.ctrlKey && navigator.platform.toUpperCase().includes('MAC');
}

export function isPrimaryUnmodifiedClick(event: MouseEvent) {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

export async function navigateWithDraft(href: string, saveDraft: () => Promise<void>) {
  await saveDraft();
  window.location.assign(href);
}
